module.exports = __webpack_public_path__ + "static/media/tuple.d254f6b0.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/immutable-tuple/dist/tuple.mjs
// module id = 805
// module chunks = 2